<template>
  <div >
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
     
    };
  },
  async created() {


  },
  mounted() {
  },
  methods: {
  
  }
}
</script>

